'use client';

import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import type { OtherInstruction } from '@/lib/services/redemption';
import {
  OTHER_INSTRUCTION_LABELS,
  OTHER_INSTRUCTION_ICONS,
  OTHER_INSTRUCTION_DESCRIPTIONS,
  OTHER_INSTRUCTION_OPTIONS
} from './constants';

export function OtherInstructionSelector({
  selected,
  onSelect
}: {
  selected: OtherInstruction | null;
  onSelect: (instruction: OtherInstruction) => void;
}) {
  return (
    <div className="space-y-2">
      <Label className="text-foreground-secondary text-sm font-medium">
        Instruction
      </Label>
      <div className="grid gap-2">
        {OTHER_INSTRUCTION_OPTIONS.map((instruction) => {
          const isActive = selected === instruction;
          const Icon = OTHER_INSTRUCTION_ICONS[instruction];

          return (
            <button
              key={instruction}
              type="button"
              onClick={() => onSelect(instruction)}
              className={cn(
                'flex items-center gap-3 rounded-lg border-2 px-4 py-3 text-left transition-all',
                isActive
                  ? 'border-foreground bg-surface-subtle'
                  : 'border-border bg-card hover:border-border-strong hover:bg-surface-subtle/50'
              )}
            >
              <Icon
                className={cn(
                  'h-5 w-5 shrink-0',
                  isActive
                    ? 'text-foreground-secondary'
                    : 'text-foreground-subtle'
                )}
              />
              <div>
                <span
                  className={cn(
                    'text-sm font-medium',
                    isActive ? 'text-foreground' : 'text-foreground-secondary'
                  )}
                >
                  {OTHER_INSTRUCTION_LABELS[instruction]}
                </span>
                <p className="text-muted-foreground text-xs">
                  {OTHER_INSTRUCTION_DESCRIPTIONS[instruction]}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
